import { MASTER_PAGE_ID, parseEntityItemId, RuleId } from '@wix/a11y-rules';
import { createRuleData } from '@wix/ambassador-promote-accessibility-v1-accessibility-report/http';
import { RuleAction } from '@wix/ambassador-promote-accessibility-v1-accessibility-report/types';
import { useErrorHandler, useHttpClient } from '@wix/fe-essentials/react';
import { useCallback, useMemo } from 'react';
import { useA11yWizardAdapter } from '../../../hooks/use-a11y-wizard-adapter';
import { getCompRefType } from '../../../utils/get-comp-ref-type';
import { useGlobalSectionState } from '../../shared/use-global-section-state';
export const useBaseMediaAlternativesHandlers = () => {
  const httpClient = useHttpClient();
  const {
    withErrorHandler
  } = useErrorHandler();
  const {
    getIsComponentInGlobalSection
  } = useGlobalSectionState();
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  const getIsNotApplicable = useCallback(ruleExecutionResult => {
    return ruleExecutionResult.every(_ref => {
      let {
        result
      } = _ref;
      return result.status === 'not-applicable';
    });
  }, []);
  const getRuleStatus = useCallback(ruleExecutionResult => {
    const isOneFailed = ruleExecutionResult.some(_ref2 => {
      let {
        result
      } = _ref2;
      return result.status === 'failed';
    });
    return isOneFailed ? 'failed' : 'passed';
  }, []);
  const openMediaElement = useCallback(nextElement => {
    const {
      id,
      breakpointId,
      tpaData
    } = nextElement;
    const nextCompRef = {
      id: (tpaData == null ? void 0 : tpaData.componentId) ?? id,
      type: getCompRefType(editorHost, breakpointId)
    };
    if (nextCompRef) {
      a11yWizardAdapter.selectComponent(nextCompRef, breakpointId);
    }
  }, [a11yWizardAdapter, editorHost]);
  const setMediaAlternatives = useCallback(async data => {
    const {
      pageId,
      id,
      breakpointId,
      type,
      branchId
    } = data;
    try {
      await withErrorHandler(async () => httpClient.request(createRuleData({
        ruleData: {
          branchId,
          breakpointId,
          elementId: id,
          pageId: getIsComponentInGlobalSection(parseEntityItemId(id, 2).entities[0]) ? MASTER_PAGE_ID : pageId,
          ruleAction: RuleAction.COMPLETED_MANUALLY,
          ruleId: RuleId.MEDIA_ALTERNATIVES,
          userSelectionRuleData: {
            mediaAlternativesRuleData: {
              mediaType: type
            }
          }
        }
      })), {
        errorCodesMap: {}
      });
    } catch (error) {
      console.error(`Failed to update media alternatives "${type}" for component ${id}`, error);
      throw error;
    }
  }, [getIsComponentInGlobalSection, httpClient, withErrorHandler]);
  return useMemo(() => ({
    getIsNotApplicable,
    getRuleStatus,
    openMediaElement,
    setMediaAlternatives
  }), [getIsNotApplicable, getRuleStatus, openMediaElement, setMediaAlternatives]);
};
//# sourceMappingURL=use-base-media-alternatives-handlers.js.map